/* angular:styles/component:css;f10540a8af45c1b9a8f6ecfae18748a75cdc155d0dbbfe040c5477e008bf07d0;/src/src/app/shared/components/modal/modal.ts */
:host {
  height: 100%;
  font-size: 0.9em;
}
/*# sourceMappingURL=modal.css.map */
